// Funktion zum zuverlässigen Ausblenden/Einblenden des Kollektionstextes
function hideCollectionDescription() {
    try {
        // Überprüfen der aktuellen URL
        const currentUrl = window.location.href;
        const isPageOne = !currentUrl.includes('page=');
        
        // Verschiedene Beschreibungs-Selektoren
        const descriptionSelectors = [
            '.rte.rte--collection-desc .collapsable_description',
            '.rte--collection-desc .collapsable_description',
            '.page-description',
            '.collection-description',
            '.rte--collection-desc',
            '.collapsable_description'
        ];

        descriptionSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            
            elements.forEach(el => {
                if (el) {
                    if (isPageOne) {
                        // Auf Seite 1 (ohne page=): Beschreibung einblenden
                        el.style.removeProperty('display');
                        el.style.removeProperty('visibility');
                        el.style.removeProperty('opacity');
                        el.style.removeProperty('height');
                        el.style.removeProperty('max-height');
                        el.style.removeProperty('overflow');
                        
                        el.removeAttribute('hidden');
                        el.removeAttribute('aria-hidden');
                        
                        el.classList.add('--collapsed');
                        el.classList.remove('hidden');
                    } else {
                        // Auf anderen Seiten: Beschreibung ausblenden
                        el.style.setProperty('display', 'none', 'important');
                        el.style.setProperty('visibility', 'hidden', 'important');
                        el.style.setProperty('opacity', '0', 'important');
                        el.style.setProperty('height', '0', 'important');
                        el.style.setProperty('max-height', '0', 'important');
                        el.style.setProperty('overflow', 'hidden', 'important');
                        
                        el.setAttribute('hidden', 'true');
                        el.setAttribute('aria-hidden', 'true');
                        
                        el.classList.remove('--collapsed');
                        el.classList.add('hidden');
                    }
                }
            });
        });
    } catch (error) {
        console.error('Fehler beim Ausblenden/Einblenden der Kollektionsbeschreibung:', error);
    }
}

// Verschiedene Methoden zur Sicherstellung der Ausführung
function initHideCollectionDescription() {
    // Sofortige Ausführung
    hideCollectionDescription();

    // Nach DOM-Laden
    document.addEventListener('DOMContentLoaded', hideCollectionDescription);

    // Bei Seitenänderungen
    if (window.history) {
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        history.pushState = function() {
            originalPushState.apply(history, arguments);
            hideCollectionDescription();
        };

        history.replaceState = function() {
            originalReplaceState.apply(history, arguments);
            hideCollectionDescription();
        };
    }

    // MutationObserver für dynamische Inhalte
    const observer = new MutationObserver((mutations) => {
        const shouldUpdate = mutations.some(mutation => 
            mutation.type === 'childList' && 
            mutation.target.classList.contains('rte--collection-desc')
        );

        if (shouldUpdate) {
            hideCollectionDescription();
        }
    });

    // Beobachten des gesamten Dokumentenbaums
    observer.observe(document.body, { 
        childList: true, 
        subtree: true 
    });
}

// Sicherstellen, dass die Funktion ausgeführt wird
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHideCollectionDescription);
} else {
    initHideCollectionDescription();
}

// Für Shopify-Themes mit AJAX-Produktladung
document.addEventListener('shopify:section:load', hideCollectionDescription);
document.addEventListener('shopify:section:select', hideCollectionDescription);

// Zusätzlicher Aufruf mit Verzögerung
setTimeout(hideCollectionDescription, 500);
setTimeout(hideCollectionDescription, 1000);
setTimeout(hideCollectionDescription, 2000);